export default __webpack_public_path__ + "static/media/uowLogo.943274c5.png";